/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { BrowserCacheLocation, Configuration, LogLevel, ProtocolMode, RedirectRequest } from "@azure/msal-browser"
import { env } from "configs"

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: env.REACT_APP_MSAL_CLIENT_ID,
    authority: env.REACT_APP_MSAL_AUTHORITY,
    redirectUri: env.REACT_APP_MSAL_REDIRECT_URI,
    postLogoutRedirectUri: env.REACT_APP_MSAL_LOGOUT_REDIRECT_URI,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage, // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      // loggerCallback: (level, message, containsPii) => {
      //   // console.log(message)
      //   if (containsPii) {
      //     return
      //   }
      //   switch (level) {
      //     case LogLevel.Error:
      //       console.error(message)
      //       return
      //     case LogLevel.Info:
      //       console.info(message)
      //       return
      //     case LogLevel.Verbose:
      //       console.debug(message)
      //       return
      //     case LogLevel.Warning:
      //       console.warn(message)
      //       return
      //     default:
      //       return
      //   }
      // },
    },
  },
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest: RedirectRequest = {
  scopes: ["User.Read", "email"],
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me", //e.g. https://graph.microsoft.com/v1.0/me
}
